// extracted by mini-css-extract-plugin
export default {"callButton":"CallButton_callButton__UXeKC","icon":"CallButton_icon__Ft2Il"};